import React from 'react';
import { Button } from '@monavate/ui-core';
import { ClickToCopy } from '@monavate/ui-core';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@monavate/ui-core';
import { closeTransactionModal } from '../../reduxStore/slices/transactionsSlice';
import { useDispatch } from 'react-redux';

const Wrapper = styled.div`
    margin-top: -5px;
    .material-symbols-sharp {
        width: 22px;
        height: 22px;
        font-weight: 300;
        color: ${(props) => props.theme['Content/primary']};
    }
    .col {
        display: inline-block;
        vertical-align: middle;
        text-transform: capitalize;
    }
`;

interface CardNumberLinkProps {
    cardData: any;
    type: string;
}
const CardNumberLink: React.FC<CardNumberLinkProps> = ({ cardData, type }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const navigateToCardsList = () => {
        dispatch(closeTransactionModal());
        if (cardData.id) {
            navigate(`/cards#${cardData.id}`);
        }
    };
    return (
        <Wrapper>
            <span className="col">
                <ClickToCopy dataTestId="card-number-link-value-type">{type}</ClickToCopy>
            </span>
            <span className="col">
                <Button
                    dataTestId="button-card-number-link-view"
                    size={'small'}
                    viewType={'tertiary'}
                    style={{ padding: '4px', marginLeft: '32px' }}
                    handleClick={navigateToCardsList}
                >
                    <span className="material-symbols-sharp">arrow_outward</span>
                </Button>
            </span>
        </Wrapper>
    );
};

export default CardNumberLink;
